import React, { startTransition } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

const container = document.getElementById('root');
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
const hydrate = () => startTransition(() => hydrateRoot(container, app));

container.hasChildNodes() ? hydrate() : createRoot(container).render(app);
